module.exports = __webpack_public_path__ + "static/media/mouthRollLower.a44ff3d8.obj";